/* ============================================================
   ZonaPhone — Upsell de accesorios en el carrito (add handler)
   Snippet: snippets/zp-cart-upsell.liquid

   El mini-cart entero está envuelto en un <form>, así que las cards NO
   pueden usar {% form 'product' %} (nested forms = HTML inválido). En vez de
   eso, cada "+ Añadir" es un <button data-zp-cu-add data-variant-id>.

   Este handler está delegado a nivel document (sobrevive los re-renders del
   drawer, que reemplazan innerHTML). Hace fetch a /cart/add.js y dispara el
   evento nativo 'product:added' (bubbling) — la clase Cart del theme lo
   escucha y re-renderiza el drawer/section solo. Sin tocar theme.js.
   ============================================================ */
(function () {
  'use strict';

  if (window.__zpCartUpsellBound) return;
  window.__zpCartUpsellBound = true;

  function addUrl() {
    if (window.routes && window.routes.cartAddUrl) return window.routes.cartAddUrl + '.js';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }
    return '/cart/add.js';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zp-cu-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        // Cadena nativa del theme: Cart escucha 'product:added' -> _rerender del
        // drawer/section. Al re-renderizarse, este botón se destruye (no hace
        // falta re-habilitarlo en el caso feliz).
        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1, productAdded: true } })
        );
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();
